import React, { Fragment } from 'react';
import { PropTypes } from 'prop-types';
import SearchForm from '../../searchForm';
import CheckboxList from '../../form/CheckboxList';
import RadioButton from '../../form/RadioButton';
import Dropdown from '../../form/Dropdown';
import StaticData from '../../../services/StaticData';
import CommonDataService from '../../../services/CommonDataService';

const ResourceFilterHeader = () => (
  <Fragment>
    <div className="col">
      <h3>Staff filter</h3>
    </div>
  </Fragment>
);

class ResourceFilter extends React.Component {

  constructor(props) {
    super(props);

    this.onReset = this.onReset.bind(this);

    this.state = {
      initialValues: {
        skillLevel: null,
        locations: [],
        languages: [],
        roles: []
      },
      languages: [],
      locations: []
    }
  }

  componentWillMount() {

    const filter = { ...this.props.initialValues };
    this.setState({ initialValues: Object.assign({}, filter) });

    CommonDataService
      .getLanguages()
      .then(response => {
        this.setState({
          languages: [...response]
        });
      });

    CommonDataService
      .getLocations()
      .then(response => {
        this.setState({
          locations: [...response]
        });
      });
  }

  onReset() {
    if (this.props.onClear) {
      this.props.onClear(this.state.initialValues);
    }
  }

  render() {
    return (
      <SearchForm
        initialValues={{ ...this.state.initialValues }}
        enableReinitialize={false}
        searchHeader={ResourceFilterHeader}
        onSubmit={this.props.onSearch}
        onReset={this.onReset}>
        <Fragment>
          <div className="box">
            <cite>Skill Level</cite>
            <RadioButton
              name="skillLevel"
              options={StaticData.Complexity} />
          </div>
          <div className="box">
            <cite>Location</cite>
            <CheckboxList
              name="locations"
              options={this.state.locations} />
          </div>
          <div className="box">
            <cite>Languages</cite>
            <Dropdown
              name="languages"
              multi={true}
              options={this.state.languages} />
          </div>
        </Fragment>
      </SearchForm>
    );
  }
}

ResourceFilter.propTypes = {
  onSearch: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
  initialValues: PropTypes.object
}

export default ResourceFilter;



// WEBPACK FOOTER //
// ./src/components/projects/ProjectSchedule/ResourceFilter.js